import { ActionTree } from "vuex";
import { RootState } from "@/store/interfaces/root";
import { CompanyState, CompanyActions } from "@/store/interfaces/company";
import { ActionTypes } from "./action-types";
import { MutationTypes } from "./mutation-types";
import { Fetch } from "@/plugins/fetch";
import moment from "moment";

export const actions: ActionTree<CompanyState, RootState> & CompanyActions = {
  /**
    Prepare company wizard in register flow
    @var commit - start mutation handler
    @param payload - {
      data: {
        company: {
            name: string;
            settings: object;
            url: string;
        };
        office: {
            name: string;
        };
        language: string;
        timezone: string;
      };
      token: string;
    }
  */
  async [ActionTypes.COMPANY_PREPARE_WIZARD]({ commit }, payload) {
    await Fetch.post("company/preparewizard", payload.token, payload.data)
      .then(res => {
        commit(MutationTypes.COMPANY_SET_WIZARD, {
          status: true,
          didInvalidate: false,
          companyId: res.company_id,
          companyName: res.company_name,
          companyUrl: res.company_url,
          receivedAt: moment().unix(),
          connectionError: false
        });
      })
      .catch(error => {
        commit(MutationTypes.COMPANY_SET_WIZARD, {
          status: false,
          didInvalidate: true,
          companyId: "",
          companyName: "",
          companyUrl: "",
          receivedAt: moment().unix(),
          connectionError: true
        });
        throw error;
      });
  },

  /**
    Fetch company information
    @var commit - start mutation handler
    @param payload - {
      id: string;
      token: string;
    }
  */
  async [ActionTypes.COMPANY_FETCH_COMPANY]({ commit }, payload) {
    await Fetch.get(`company/${payload.id}`, payload.token)
      .then(res => {
        commit(MutationTypes.COMPANY_SET_COMPANY, {
          status: true,
          didInvalidate: false,
          companyId: res.id,
          companyName: res.name,
          companyUrl: res.url,
          receivedAt: moment().unix(),
          connectionError: false
        });
      })
      .catch(error => {
        commit(MutationTypes.COMPANY_SET_COMPANY, {
          status: false,
          didInvalidate: true,
          companyId: "",
          companyName: "",
          companyUrl: "",
          receivedAt: moment().unix(),
          connectionError: true
        });
        throw error;
      });
  }
};
